import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { injectIntl } from 'react-intl';
import { find } from 'lodash';

import ShoppingAmount from '../containers/shopping/amount/item';

function AmountEdit({ ...props }) {
    const bag = useQuery('bag')?.data || [];
    const [update, setUpdate] = useState(false);
    const [data, setData] = useState([]);

    const id = props.match.params.id;

    useEffect(() => {
        setData(find(bag, { index: id }));
        if (update) setUpdate(false);
    }, [update, id]);

    return (
        <div className="page-wrapper page-amount">
            <ShoppingAmount item={data} />
        </div>
    );
}

export default injectIntl(React.memo(AmountEdit));
